export const UPDATE_HIDDEN_FIELDS = 'UPDATE_HIDDEN_FIELDS';

export default function hiddenFields(state = [], action) {
    switch (action.type) {
        case UPDATE_HIDDEN_FIELDS:
            return action.payload;
        default:
            return state;
    }
}

export function updateHiddenFields(fields) {
    return {
        type: UPDATE_HIDDEN_FIELDS,
        payload: fields
    };
}
